import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";

export const MODIFY_GAME_TIMER = gql`
  query ModifyGameTimer($timerId: Int!, $duration: Int!, $modifyType: GameTimerModifyType!) {
    modifyGameTimer(timerID: $timerId, modifyType: $modifyType, duration: $duration) {
      id
      schoolClassID
      startAt
      endAt
      duration
      createdAt
      status {
        ...statusFields
      }
    }

  }
  ${StatusFragment}
`;
